/* NBB — search panel "pop bung ra" (open) + "thu vô" (collapse) animations.
   The theme's <details-modal class="header__search"> shows/hides .header__search-inner
   purely via the <details> open attribute (closed → content display:none), so:
     • OPEN  — the CSS keyframe (§39) only fires the first render; on later opens it
               stays "finished". We restart it via the Web Animations API.
     • CLOSE — display:none kills any CSS transition, so there is no native close
               animation. We intercept the [open] removal, RE-ADD [open] to keep the
               panel rendered, play a JS collapse, then really close on finish.
   REVERT: delete this file + its <script> tag in snippets/color-scheme-vars.liquid
   + the §39/§40 blocks in nbb-chrome-ui.css. */
(function () {
  var OPEN_MS = 520;
  var CLOSE_MS = 260;

  function wire(modal) {
    if (modal.__nbbPop) return;
    modal.__nbbPop = true;
    var det = modal.querySelector('details');
    if (!det) return;
    var closing = false;

    function panel() { return det.querySelector('.header__search-inner'); }

    // OPEN → restart the CSS pop each time
    det.addEventListener('toggle', function () {
      if (!det.open || closing) return;
      var el = panel();
      if (!el) return;
      requestAnimationFrame(function () {
        var a = el.getAnimations().find(function (x) {
          return x.animationName === 'nbb-search-pop';
        });
        if (a) { a.currentTime = 0; a.play(); }
      });
    });

    // CLOSE → intercept, keep rendered, play collapse, then close for real
    var obs = new MutationObserver(function () {
      if (det.open || closing) return;
      var el = panel();
      if (!el) { return; }
      closing = true;
      // keep the panel rendered; suppress the CSS open-pop while collapsing
      el.classList.add('nbb-search-closing');
      det.setAttribute('open', '');
      // cancel any in-flight open animation so it doesn't fight the collapse
      el.getAnimations().forEach(function (x) {
        if (x.animationName === 'nbb-search-pop') x.cancel();
      });
      var a = el.animate(
        [
          { opacity: 1, transform: 'scale(1) translateY(0)' },
          { opacity: 0, transform: 'scale(0.86) translateY(-12px)' }
        ],
        { duration: CLOSE_MS, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
      );
      function finish() {
        a.cancel();
        det.removeAttribute('open');     // real close (panel goes display:none)
        el.classList.remove('nbb-search-closing');
        requestAnimationFrame(function () { closing = false; });
      }
      a.onfinish = finish;
      a.oncancel = function () {};
    });
    obs.observe(det, { attributes: true, attributeFilter: ['open'] });
  }

  function scan() {
    document.querySelectorAll('details-modal.header__search').forEach(wire);
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  setTimeout(scan, 800);
})();
